
export function overlayLoading(value) {
  return { type: "OVERLAY_LOADING", payload: value };
}
